// Servicios API para control de dispositivos
import { api } from './api';

// Control individual de dispositivos
export const cambiarEstadoTarjeta = async (tarjetaId, estatusDispositivo) => {
    try {
        const response = await api.patch(`/dispositivos/tarjeta/${tarjetaId}/estado`, {
            estatusDispositivo
        });
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

export const cambiarEstadoSensor = async (sensorId, estatusDispositivo) => {
    try {
        const response = await api.patch(`/dispositivos/sensor/${sensorId}/estado`, {
            estatusDispositivo
        });
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

// Consultas de estado
export const getEstadoDispositivosProyecto = async (proyectoId, soloApagados = false) => {
    try {
        const params = soloApagados ? { soloApagados: true } : {};
        const response = await api.get(`/dispositivos/proyecto/${proyectoId}/estado`, { params });
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

export const getDispositivosAlwaysOn = async (proyectoId) => {
    try {
        const response = await api.get(`/dispositivos/proyecto/${proyectoId}/always-on`);
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

// Control masivo
export const cambiarEstadoMasivo = async (estatusDispositivo, dispositivos) => {
    try {
        const response = await api.patch('/dispositivos/masivo/estado', {
            estatusDispositivo,
            dispositivos
        });
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

// Administración de dispositivos (solo admin/superadmin)
export const configurarAlwaysOn = async (dispositivos) => {
    try {
        const response = await api.patch('/dispositivos/configurar-always-on', {
            dispositivos
        });
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};
